const routes = [
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/IndexPage.vue"),
        name: "Home",
      },
      {
        path: "/projects",
        component: () => import("pages/ProjectsPage.vue"),
      },
      {
        path: "/projects-sale",
        component: () => import("pages/CarbonSaleProjectPage.vue"),
      },
      {
        path: "/projects-sale/:id",
        component: () => import("pages/CarbonSalePage.vue"),
        props: true,
      },
      {
        path: "/projects-investment/:id",
        component: () => import("pages/CarbonInvestmentPage.vue"),
        props: true,
        meta: { showBack: true },
      },
      {
        path: "/projects-agroforestry/:id",
        component: () => import("pages/AgroforestryPage.vue"),
        props: true,
        meta: { showBack: true },
      },
      {
        path: "/dashboard",
        component: () => import("pages/WalletPage.vue"),
        meta: { showBack: true, authDialogDismissible: false },
      },
      { path: "/contact", component: () => import("pages/ContactPage.vue") },
      { path: "/legal", component: () => import("pages/LegalPage.vue") },
      {
        path: "/support",
        component: () => import("pages/SupportPage.vue"),
      },
      {
        path: "/support/:route",
        component: () => import("pages/GuideDetail.vue"),
        props: true,
        meta: { showBack: true },
      },
      {
        path: "/token",
        component: () => import("pages/NewTokenPage.vue"),
        meta: { showBack: true },
      },
      {
        path: "/play",
        component: () => import("pages/CominSoonPage.vue"),
        meta: { showBack: true },
      },
      {
        path: "/game",
        component: () => import("pages/GamePage.vue"),
        meta: { hideLayoutChrome: true },
      },
      {
        path: "/:catchAll(.*)*",
        component: () => import("pages/ErrorNotFound.vue"),
      },
      {
        path: "/farmer",
        component: () => import("pages/FarmerPage.vue"),
        name: "FarmerPage",
      },
      {
        path: "/farmer-form",
        component: () => import("pages/FarmerForm.vue"),
        name: "FarmerForm",
      },
      {
        path: "/project-application",
        component: () => import("pages/Level1Form.vue"),
        name: "Level1Form",
      },
      {
        path: "/developer",
        component: () => import("pages/DeveloperPage.vue"),
        name: "DeveloperPage",
      },
      {
        path: "/carbon-operations",
        component: () => import("pages/CarbonOperationsPage.vue"),
        name: "CarbonOperationsPage",
        meta: {
          showBack: true,
          carbonExecutionMode: "DIRECT_WALLET",
          requiresSuperAdmin: true,
        },
      },
    ],
  },
  {
    path: "/auditor",
    component: () => import("pages/AuditorPage.vue"),
    name: "AuditorPage",
  },
  {
    path: "/benefitor-form",
    component: () => import("pages/BenefitorForm.vue"),
    name: "BenefitorForm",
  },
  {
    path: "/admin-manage-users",
    component: () => import("pages/ManageUsers.vue"),
    name: "ManageUsers",
  },
  {
    path: "/owner-form",
    component: () => import("pages/OwnerForm.vue"),
    name: "OwnerForm",
  },
  {
    path: "/certifier-form",
    component: () => import("pages/CertifierForm.vue"),
    name: "CertifierForm",
  },
  {
    path: "/admin/treasury",
    component: () => import("pages/admin/TreasuryConsolePage.vue"),
    meta: { requiresSuperAdmin: true },
    children: [
      {
        path: "",
        name: "TreasuryConsoleOverview",
        component: () =>
          import("components/admin/treasury/overview/OverviewTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "overview" },
      },
      {
        path: "bct",
        name: "TreasuryConsoleBct",
        component: () =>
          import("components/admin/treasury/bct/BctSupplyTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "bct" },
      },
      {
        path: "fees",
        name: "TreasuryConsoleFees",
        component: () =>
          import("components/admin/treasury/fees/TreasuryFeesTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "fees" },
      },
      {
        path: "yield",
        name: "TreasuryConsoleYield",
        component: () =>
          import("components/admin/treasury/yield/YieldRouterTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "yield" },
      },
      {
        path: "emissions",
        name: "TreasuryConsoleEmissions",
        component: () =>
          import(
            "components/admin/treasury/emissions/EmissionsTab.vue"
          ),
        meta: { requiresSuperAdmin: true, treasuryTab: "emissions" },
      },
      {
        path: "governance",
        name: "TreasuryConsoleGovernance",
        component: () =>
          import(
            "components/admin/treasury/multisig/MultisigQueueTab.vue"
          ),
        meta: { requiresSuperAdmin: true, treasuryTab: "governance" },
      },
      {
        path: "multisig",
        redirect: { name: "TreasuryConsoleGovernance" },
        meta: { requiresSuperAdmin: true },
      },
      {
        path: "receipt-relays",
        name: "TreasuryConsoleReceiptRelays",
        component: () =>
          import("components/admin/treasury/relays/ReceiptRelaysTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "receipt-relays" },
      },
      {
        path: "kyc",
        name: "TreasuryConsoleKyc",
        component: () =>
          import("components/admin/treasury/kyc/KycBulkTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "kyc" },
      },
      {
        path: "audit-log",
        name: "TreasuryConsoleAuditLog",
        component: () =>
          import("components/admin/treasury/audit/AuditLogTab.vue"),
        meta: { requiresSuperAdmin: true, treasuryTab: "audit-log" },
      },
    ],
  },
  {
    path: "/admin",
    component: () => import("pages/AdminPage.vue"),
    name: "AdminPage",
  },
  {
    path: "/coming-soon",
    component: () => import("pages/CominSoonPage.vue"),
    name: "CominSoonPage",
  },
];



export default routes;
